export default {"src":"/_next/static/media/option1Tab.af5bfe98.svg","height":248,"width":308,"blurWidth":0,"blurHeight":0};